export enum ActionIcon {
    TIME = "clock",
    SUBMIT_REQUEST = '<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H11M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 15V18M17 21V18M17 18H14M17 18H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    CHECK_REQUEST = "checkmarkcircle",
    EDIT = "edit",
    WITHDRAW = "undo",
}
export enum RequestFormattedStatus {
    SUBMITTED = "Submitted",
    REVIEW_CORE_TEAM = "Review-Coreteam",
    REVIEW_STEERING_COMMITTEE = "Review-Steering-Committee",
    WITHDRAWN = "Withdrawn",
    MODIFIED = "Modified",
    REJECTED = "Rejected",
}
export enum RequestStatus {
    IN_PROGRESS = "0",
    APPROVED = "1",
    REJECTED = "2"
}
export enum StepDecision {
    APPROVED = "0",
    REJECTED = '1'
}
export enum Action {
    REQUEST = "Request",
    MODIFY = "Modify",
    VERIFY = "Verify",
    WITHDRAW = "Withdraw",
    APPROVE = "Approve",
}